import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenericService } from '../../services/generic.service';

@Component({
  selector: 'app-rigth-area',
  templateUrl: './rigth-area.component.html',
  styleUrls: ['./rigth-area.component.scss']
})
export class RigthAreaComponent implements OnInit {

  data: any;

  constructor(
    private genericService: GenericService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.getData();
  }
  
  getData() {
    var params = new HttpParams()
      .set('orderBy', 'DataDePublicacao')
      .set('whichUrl', 'Notícias e Eventos')
      .set('top', "3");
    this.genericService.getGenericMultiSearch(params).subscribe(result => {
      this.data = result;
    })
  }

  redirectnoticia(noticia: any){
    var text = noticia?.Categoria;
    if(text=="Educacao Financeira"){
      this.router.navigateByUrl('/noticias-e-eventos/educacao-financeira/detalhe/'+noticia.ID);
    }else if(text=="Inclusao Financeira"){
      //this.router.navigateByUrl('/banco/pesquisa/');
      this.router.navigateByUrl('/noticias-e-eventos/inclusao-financeira/detalhe/'+noticia.ID);
    }
  }

  truncateHTML(item: any, charlimit: number): string {
    var text = item?.Descricao;
    if (!text || text.length <= charlimit) {
      return text;
    }
    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charlimit) + "...";
    return shortened;
  }

  limitarCaracteresTitulo(item: any, charlimit: number): string {
    var text = item;
    if (!text || text.length <= charlimit) {
      return text;
    }
    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charlimit) + "...";
    return shortened;
  }

}
